import { Switch as ChakraSwitch, SwitchProps as ChakraSwitchProps, forwardRef } from '@chakra-ui/react';
import React from 'react';

import { selectLikePropTypes, selectLikeDefaultProps } from '_helpers';

export type SwitchProps = ChakraSwitchProps;

const propTypes = {
  ...selectLikePropTypes
};

const defaultProps = {
  ...selectLikeDefaultProps
};

const Switch = forwardRef<SwitchProps, 'input'>(
  (props: SwitchProps & typeof defaultProps, ref): React.ReactElement => {
    return <ChakraSwitch ref={ref} {...props} />;
  }
);

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
Switch.displayName = 'Switch';
export default Switch;
